
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DeletedDxReport, PaginationVM } from '@/models'
import { getDeletedDxReport } from '@/components/diagnostics/diagnostics.service'
import moment from 'moment'
import xlsx from 'json-as-xlsx'

@Component
export default class DeletedDxReportView extends Vue {
  public searchQuery = ''
  public items: DeletedDxReport[] = []
  public perPage = 50
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {
    currentPage: 1,
    pageSize: 50,
    totalCount: 0,
    totalPages: 0
  } as PaginationVM

  public fields = [
    { key: 'index', label: '#', sortable: false },
    { key: 'npi', label: 'NPI', sortable: true },
    { key: 'nombreDelPcp', label: 'PCP Name', sortable: true },
    { key: 'insuranceContractNo', label: 'INS Contract No', sortable: true },
    { key: 'diagnosticID', label: 'Diagnostic', sortable: true },
    { key: 'serviceDate', label: 'Service Date/Upload Date', sortable: true },
    { key: 'diagnosisSource', label: 'Diagnosis Source', sortable: true },
    { key: 'provider', label: 'Provider', sortable: true },
    { key: 'reason', label: 'Reason', sortable: true },
    { key: 'otherReason', label: 'Other Reason', sortable: true },
    { key: 'dateDeleted', label: 'Date Deleted', sortable: true }
  ]

  get searchLabel() {
    return 'Search By (NPI, INS Contract No, Diagnostic):'
  }

  private async created() {
    await this.loadReport()
  }

  @Watch('perPage')
  perPageChange() {
    this.loadReport(1)
  }

  public async onPageChange(pageNumber: number) {
    await this.loadReport(pageNumber)
  }

  public async filter() {
    await this.loadReport(1)
  }

  public async cleanFilter() {
    this.searchQuery = ''
    await this.loadReport(1)
  }

  public async loadReport(pageNumber = 1) {
    const res = await getDeletedDxReport(
      pageNumber,
      this.perPage,
      this.searchQuery
    )
    this.items = Array.isArray(res?.data) ? res.data : []
    const paginationHeader = res?.headers?.['x-pagination']
    this.pagination = paginationHeader
      ? JSON.parse(paginationHeader)
      : ({
          currentPage: pageNumber,
          pageSize: this.perPage,
          totalCount: this.items.length,
          totalPages: 1
        } as PaginationVM)
  }

  public formatDate(value: string | Date | null) {
    if (!value) return ''
    return moment(value).format('MM/DD/YYYY')
  }

  public async exportTable() {
    const response = await getDeletedDxReport(1, 999999, this.searchQuery)
    const items = response.data || []
    const data = [
      {
        sheet: 'Deleted DX Report',
        columns: this.fields
          .filter(c => c.key !== 'index')
          .map(c => ({ label: c.label, value: c.key })),
        content: items.map(c => ({
          ...c,
          serviceDate: this.formatDate(c.serviceDate),
          dateDeleted: this.formatDate(c.dateDeleted)
        }))
      }
    ]
    xlsx(data, {
      fileName: 'Deleted DX Report',
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false
    })
  }
}
